import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Fce } from './fce';
import { SharedService } from '../_shared/shared.service';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { DbConstants } from '../_consts/db-constants';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private tokenRefresh;
    private msgsRefresh;
    private min1 = 60 * 1000 //1min
    private min5 = 5 * this.min1 //5min
    private refreshTime = 30 * this.min1 //30min
    private minRefreshTime = 10 * 1000 //10sec
    public logging
    private fcmListener

    constructor(private http: HttpClient, protected shared: SharedService, private router: Router) {
        try {
            const logged = JSON.parse(shared.storageGet('login'));
            const diff = this.tokenValidDiff(logged)
            
            if (logged && diff > this.minRefreshTime) {
                this.shared.login = logged
                this.controlUser(false)
            }
        } catch (error) {
            this.shared.login = null
        }
    }

    tokenValidDiff(loginObj) {
        const time = new Date().getTime() * 0.001
        return Math.round(loginObj.expires_at - time) * 1000
    }

    async loginUser(params, fastLogin = false) {
        if (this.logging)
            return
        this.logging = true
        params.id_browser = this.shared.storageGet("id_browser") || null
        const response: any = await this.http.post(`${environment.apiUrl}${fastLogin ? 'fastLogin' : 'login'}`, params).toPromise().catch((e) => this.shared.logError(e));
        if (!response) {
            this.logging = false
            return
        }

        this.processLoginAndEtc({
            ...response.login,
            browser_sett: response.browser_sett
        }, response.rights, response.messages, response.constants, true)
        this.logging = false

        if (response.remember_hash) {
            try {
                let remembers: any = this.shared.storageGet('remembers')
                remembers = remembers ? JSON.parse(remembers) : {}
                remembers[this.shared.login.id_user] = {
                    fullname: this.shared.login.fullname,
                    id_user: this.shared.login.id_user,
                    hash: response.remember_hash
                }
                this.shared.storageSet('remembers', JSON.stringify(remembers));
            } catch (error) {
                this.shared.logError(error)
            }
        }

        this.setTokenRefresh()
        if (!fastLogin)
            this.requestFcmToken()
    }

    async controlUser(refreshToken = true, showLoad = true) {
        if (!this.shared.login || !this.shared.login.id_user) {
            this.shared.rightsAll = null
            return
        }
        this.shared.refreshingToken = true
        const response: any = await this.http.post(`${environment.apiUrl}refresh`, {
            id_user: this.shared.login.id_user,
            setting: !this.shared.rightsAll,
            refresh: refreshToken,
            hideLoader: !showLoad,
            id_browser: this.shared.storageGet("id_browser") || null
        }).toPromise().catch((e) => this.shared.logError(e));
        if (!response) {
            this.shared.refreshingToken = false
            return
        }

        this.processLoginAndEtc({
            ...this.shared.login,
            ...response.token,
            fcm_token: response.token,
            browser_sett: response.browser_sett
        }, response.rights, response.messages, response.constants)
        this.shared.refreshingToken = false

        this.setTokenRefresh()
    }

    processLoginAndEtc(login, rights, messages, constants, controlLang = false) {
        this.shared.storageSet('login', JSON.stringify(login));
        this.shared.login = login
        this.shared.login.id_browser = this.shared.storageGet("id_browser") || ""
        if (rights)
            this.shared.rightsAll = rights
        if (messages)
            this.shared.messages.next(messages)
        if (constants) {
            DbConstants.parse(constants)
        }
        console.log("LOGIN/REFRESH", login, rights, messages, constants);

        if (controlLang && !Fce.empty(login.lang) && login.lang != this.shared.transService.currentLang) {
            this.shared.broadcast(
                "CHANGE_LANG", login.lang
            )
        }

        //Refresh in iframe
        if (this.shared.loadedIframe && this.shared.loadedIframe.loaded) {
            this.shared.loadedIframe.sendLogin()
        }

        if (login.fcm_token) {
            this.listenFcm()
        }
    }
    requestFcmToken() {
        // const isSupported = () =>
        // 'Notification' in window &&
        // 'serviceWorker' in navigator &&
        // 'PushManager' in window

        // if(!isSupported()){
        //     this.shared.warning("FCM NOT SUPPORTED IN THIS BROWSER")
        //     return
        // }

        if (environment.firebase) {
            const messaging = getMessaging();
            console.log("bbbb", environment.firebase)
            getToken(messaging,
                { vapidKey: environment.firebase.vapidKey }).then(
                    (currentToken) => {
                        if (currentToken) {
                            this.listenFcm();
                            this.setFcmBackend(currentToken)
                        } else
                            this.shared.warning("FCM TOKEN NOW AVAILABLE");
                    }).catch((err) => {
                        if (!(err?.includes && err.includes("The notification permission was not granted")))
                            this.shared.warning('FCM TOKEN ERROR: ' + err);
                    });
        }
    }

    listenFcm() {
        if (this.fcmListener)
            this.fcmListener()
        console.log("LISTEN FCM");
        if (environment.firebase) {
            this.fcmListener = onMessage(getMessaging(), (payload) => {
                if (payload?.notification)
                    this.shared.info(payload?.notification.title, payload?.notification.body, 0);
                else
                    this.shared.warning("FCM MESSAGE", JSON.stringify(payload));
            });
        }
    }

    setFcmBackend(token) {
        this.shared.login.fcm_token = token
        this.http.post(`${environment.apiUrl}${'setFcm'}`, { token }).toPromise().catch((e) => this.shared.logError(e));
    }


    logoutUser(goToLogin: boolean) {
        this.shared.reset()
        if (goToLogin)
            this.router.navigate(['/login']);

        if (this.tokenRefresh)
            clearTimeout(this.tokenRefresh)
        if (this.msgsRefresh)
            clearTimeout(this.msgsRefresh)

        if (this.fcmListener) {
            this.fcmListener()
        }
    }

    setTokenRefresh() {
        if (this.tokenRefresh) {
            clearTimeout(this.tokenRefresh)
            this.tokenRefresh = null
        }

        if (this.shared.isLoggedIn() && this.shared.login.expires_at) {

            const diff = this.tokenValidDiff(this.shared.login)
            const self = this

            if (diff > this.minRefreshTime) {
                this.tokenRefresh = setTimeout(() => {
                    console.log("REFRESH TOKEN");
                    self.controlUser(true, false)
                }, diff > this.refreshTime ? this.refreshTime : diff);
            } else
                this.logoutUser(true)
        }

        this.setMsgsRefresh()
    }

    setMsgsRefresh() {
        if (this.msgsRefresh) {
            clearTimeout(this.msgsRefresh)
            this.msgsRefresh = null
        }
        if (this.shared.isLoggedIn() && environment.headerMessages) {
            const self = this
            this.msgsRefresh = setTimeout(async () => {
                if (this.shared.isLoggedIn() && !this.shared.refreshingToken) {
                    const response: any = await this.http.post(`${environment.apiUrl}msg/getMessages`, { hideLoader: true }).toPromise().catch((e) => this.shared.logError(e));
                    if (response && response.messages)
                        this.shared.messages.next(response.messages)
                    self.setMsgsRefresh()
                }
            }, this.min5);

        }
    }

}